import { connect } from 'react-redux';
import { basketSelectors } from '@store/basket/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';

import { SpaDay } from './SpaDay';
import { StateProps } from './SpaDay.types';
import { formValueSelector } from 'redux-form';
import { SPA_PACKAGE_FORM_NAME } from './SpaPackageModal/shared';
import moment from 'moment';

const mapStateToProps = (state): StateProps => {
  const journeyParams = yourJourneySelectors.getParsedJourneyParams(state);

  return {
    journeyParams,
    basketDetails: basketSelectors.getBasketDetails(state),
    selectedDate: moment(
      formValueSelector(SPA_PACKAGE_FORM_NAME)(state, 'date') ||
        yourJourneySelectors.getParsedJourneyParams(state).spaDate
    ),
  };
};

export const SpaDayConnected: any = connect(mapStateToProps)(SpaDay);
